export default "__VITE_ASSET__BPzfIJHM__"